var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPngicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16.67 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#9e9e9e;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-1.67 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 20,
    height: 20
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PNG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.63,4.61l-2.91-2.9A5.8,5.8,0,0,0,9.6,0H5.83A4.17,4.17,0,0,0,1.67,4.17V15.83A4.17,4.17,0,0,0,5.83,20h8.34a4.17,4.17,0,0,0,4.16-4.17V8.74A5.82,5.82,0,0,0,16.63,4.61ZM15.45,5.79a4.36,4.36,0,0,1,.67.88H12.5a.84.84,0,0,1-.83-.84V2.22a4,4,0,0,1,.87.67l2.91,2.9Zm1.22,10a2.5,2.5,0,0,1-2.5,2.5H5.83a2.51,2.51,0,0,1-2.5-2.5V4.17a2.51,2.51,0,0,1,2.5-2.5H9.6a2.68,2.68,0,0,1,.4,0V5.83a2.5,2.5,0,0,0,2.5,2.5h4.15c0,.14,0,.27,0,.41Z",
    transform: "translate(-1.67 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.72,9.77H4.55a.56.56,0,0,0-.55.56v4.34a.56.56,0,0,0,.55.56.55.55,0,0,0,.54-.56V13.34h.63a1.79,1.79,0,0,0,0-3.57Zm0,2.45H5.1V10.9h.62a.66.66,0,1,1,0,1.32Zm5.9-1.91v4.2a.63.63,0,0,1-1.22.27l-1-2.35v2.2a.54.54,0,0,1-.53.54.53.53,0,0,1-.52-.54v-4.2A.65.65,0,0,1,9,9.77a.66.66,0,0,1,.59.39l1,2.35v-2.2a.54.54,0,0,1,.53-.54A.53.53,0,0,1,11.62,10.31Zm1.1,3.13V11.5a1.7,1.7,0,0,1,1.62-1.73,1.59,1.59,0,0,1,1.1.43.53.53,0,0,1-.34.92h0a.51.51,0,0,1-.34-.13.57.57,0,0,0-.48-.13.62.62,0,0,0-.47.62v2a.59.59,0,0,0,.63.6.61.61,0,0,0,.55-.62v-.32h-.1a.49.49,0,0,1-.49-.5.5.5,0,0,1,.49-.51h.66a.5.5,0,0,1,.49.51v.84a1.67,1.67,0,0,1-1.61,1.69,1.7,1.7,0,0,1-1.67-1.73Z",
    transform: "translate(-1.67 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPngicon);
export default __webpack_public_path__ + "static/media/pngicon.406a0e315be31d355f12df7765708504.svg";
export { ForwardRef as ReactComponent };